<ng-container *transloco="let t">
  <mat-menu #appMenu="matMenu" xPosition="before">
    @if (mobile || roleId === 13) {
      <p class="space-sm-left space-sm-right menu-item flex align-center">
        <img src="/assets/logo/logo_default_small.png" height="20px" alt="Application logo" /> {{ version }}
      </p>
      <hr />
    }
    @if ('user.profile.view' | capabilityCheck) {
      <a mat-menu-item routerLink="/user/me">
        <mat-icon class="material-symbols-outlined">account_box</mat-icon> {{ t('components.useravatar.profile') }}
      </a>
    }
    @if ('user.notification.settings' | capabilityCheck) {
      <a mat-menu-item routerLink="/user/notifications">
        <mat-icon class="material-symbols-outlined">notifications_active</mat-icon> {{ t('menu.user.my_notifications') }}
      </a>
    }

    @if (timeTracking.available()) {
      <a mat-menu-item routerLink="/my/time-tracking">
        <mat-icon class="material-symbols-outlined">schedule</mat-icon> {{ t('components.useravatar.time_tracking') }}
      </a>
    }

    @if (('hr.vacation.read' | hrCapabilityCheck) && hasLinkedPersonnel && hrFeatures.features().vacationEmployeeView) {
      <a mat-menu-item routerLink="/my/vacations">
        <mat-icon class="material-symbols-outlined">beach_access</mat-icon> {{ t('components.useravatar.vacation') }}
      </a>
    }

    @if (('hr.wishes.read' | hrCapabilityCheck) && hasLinkedPersonnel) {
      <a mat-menu-item routerLink="/my/wishes">
        <mat-icon class="material-symbols-outlined">interests</mat-icon> {{ t('components.useravatar.wish_planner') }}
      </a>
    }

    @if (('hr.payslip.read' | hrCapabilityCheck) && hasLinkedPersonnel) {
      <a mat-menu-item routerLink="/my/payslip">
        <mat-icon class="material-symbols-outlined">payments</mat-icon> {{ t('components.useravatar.payslip') }}
      </a>
    }

    <a mat-menu-item routerLink="/user/mfa">
      <mat-icon>security</mat-icon> {{ t('components.useravatar.security') }}
    </a>

    <button mat-menu-item type="button" data-testid="user-menu-logout-btn" (click)="onLogoutClicked()">
      <mat-icon>exit_to_app</mat-icon> Logout
    </button>
  </mat-menu>
  @if (userLogin) {
    <button mat-button [matMenuTriggerFor]="appMenu" [matBadge]="outbox.pendingCount() || null" matBadgeColor="warn" [matBadgeHidden]="outbox.pendingCount() === 0">
      <span class="hidden-xs"> {{ t('components.useravatar.greeting') }}, {{ userName }} </span>
      <mat-icon class="visible-xs">account_box</mat-icon>
      <mat-icon>more_vert</mat-icon>
    </button>
  }
</ng-container>
